import { MAX_TOKENS_JE_VERANSTALTUNG } from './codes.js';
/**
 * E-Mail-Versand der Zugangskarten (Änderungsanforderung ÄA-7).
 *
 * §26 schließt externe Dienste aus; der Auftraggeber verlangt für Online-Veranstaltungen gleichwohl
 * einen direkten Versand der DIN-A6-Zugangskarten per SMTP. Die Abweichung ist in
 * `docs/AENDERUNGSANFORDERUNGEN.md` (ÄA-7) dokumentiert und freigegeben.
 *
 * **Die SMTP-Zugangsdaten stehen hier nicht.** Sie kommen ausschließlich aus der `.env` (§5.1,
 * §7.9) — wie `ADMIN_PASSWORD` oder `TOKEN_ENCRYPTION_KEY`. Dieses Modul kennt nur den
 * unbedenklichen, im Backend gepflegten Teil: Absendername, Absenderadresse, Betreff und Mailtext.
 *
 * Dieses Modul enthält ausschließlich Pfade, Grenzen und Typen (§41.2).
 */
export const EMAIL_EINSTELLUNGEN_ADMIN_PATH = '/api/v1/admin/email-einstellungen';
/** Feldgrenzen. Serverseitig verbindlich, im Formular nur als Bedienhilfe. */
export const EMAIL_VERSAND_GRENZEN = {
    absenderName: 200,
    absenderAdresse: 320,
    betreff: 200,
    mailtext: 20_000,
    /** Höchstzahl der Adressen je Versandvorgang — dieselbe Grenze wie bei Tokens (§7.5). */
    maxEmpfaenger: MAX_TOKENS_JE_VERANSTALTUNG,
};
/** Die Platzhalter, die im Mailtext ersetzt werden. Der Token steht sonst nur im PDF-Anhang. */
export const EMAIL_PLATZHALTER = ['token', 'veranstaltung', 'datum', 'ort', 'link'];
/** Grobe, serverseitig ausreichende Prüfung einer E-Mail-Adresse. */
const EMAIL_MUSTER = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function istGueltigeEmailAdresse(wert) {
    return (wert.length > 0 &&
        wert.length <= EMAIL_VERSAND_GRENZEN.absenderAdresse &&
        EMAIL_MUSTER.test(wert));
}
export function emailVersandPfad(veranstaltungId) {
    return `/api/v1/admin/veranstaltungen/${veranstaltungId}/tokens/email-versand`;
}
export function emailVersandStatusPfad(veranstaltungId) {
    return `${emailVersandPfad(veranstaltungId)}/status`;
}
//# sourceMappingURL=email.js.map